// extracted by mini-css-extract-plugin
export default {"icon":"_4Q7TrtkDCzQT7EpgzC9ce6","right":"_2YRI0iUBLjT2JhiEaQglA4","left":"_3gpAEAw63CWoxJWzTielZo","spin":"_4s54PcShERNBKHxMBZk5gV","pulse":"_3Aai2ZUcH7EsX9OmwnaFKO"};